/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 73156:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var BlogCarousel = __webpack_require__(89831);
module.exports = BlogCarousel;

/***/ }),

/***/ 89831:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
var _objectSpread = (__webpack_require__(91903)["default"]);
var _reactJsxRuntime = __webpack_require__(20997);
__webpack_require__(45128);
var React = __webpack_require__(16689);
var _require = __webpack_require__(31901),
  LandingContext = _require.LandingContext;
var Variations = __webpack_require__(6996);
var schema = __webpack_require__(14023);
var BlogCarousel = function BlogCarousel(_ref) {
  var index = _ref.index,
    component = _ref.component;
  var _React$useContext = React.useContext(LandingContext),
    components = _React$useContext.landingData.components;
  var json = component || components[index];
  if (!Object.keys(json.data).length) return null;
  return /*#__PURE__*/_jsx(Variations, {
    json: json,
    schema: schema,
    render: function render(_ref2) {
      var Variation = _ref2.Variation;
      return /*#__PURE__*/_reactJsxRuntime.jsx(Variation, _objectSpread({}, json.data));
    }
  });
};
module.exports = BlogCarousel;

/***/ }),

/***/ 14023:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var normalVariation = __webpack_require__(48163);
module.exports = {
  normal: {
    component: normalVariation
  }
};

/***/ }),

/***/ 48163:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
var React = __webpack_require__(16689);
var _require = __webpack_require__(31901),
  LandingContext = _require.LandingContext;
var CardBlogCarousel = __webpack_require__(40490);
var CardBlogCarouselMobile = __webpack_require__(284);
var Normal = function Normal(_ref) {
  var blogEntries = _ref.blogEntries,
    title = _ref.title;
  var _React$useContext = React.useContext(LandingContext),
    _React$useContext$lan = _React$useContext.landingConfig,
    deviceType = _React$useContext$lan.deviceType,
    jsDisabled = _React$useContext$lan.jsDisabled,
    webp = _React$useContext$lan.webp;
  var Component = deviceType === 'mobile' ? CardBlogCarouselMobile : CardBlogCarousel;
  return /*#__PURE__*/_jsx("div", {
    className: "seo-ui-blog-carousel-container"
  }, void 0, /*#__PURE__*/_jsx(Component, {
    blogEntries: blogEntries,
    title: title,
    supportWebP: webp,
    jsDisabled: jsDisabled
  }));
};
module.exports = Normal;

/***/ }),

/***/ 90029:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/jsx");

/***/ }),

/***/ 91903:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/objectSpread2");

/***/ }),

/***/ 40490:
/***/ ((module) => {

"use strict";
module.exports = require("@seo-frontend-components/card-blog-carousel");

/***/ }),

/***/ 284:
/***/ ((module) => {

"use strict";
module.exports = require("@seo-frontend-components/card-blog-carousel-mobile");

/***/ }),

/***/ 31901:
/***/ ((module) => {

"use strict";
module.exports = require("@splinter/context");

/***/ }),

/***/ 6996:
/***/ ((module) => {

"use strict";
module.exports = require("@splinter/variations");

/***/ }),

/***/ 45128:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.object.keys.js");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 20997:
/***/ ((module) => {

"use strict";
module.exports = require("react/jsx-runtime");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(73156);
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;
//# sourceMappingURL=index.production.js.map